// removed by extract-text-webpack-plugin
module.exports = {"add":"add___FlirV"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditorGUI/Blank/styles.scss
// module id = 459
// module chunks = 0